module.exports = __webpack_public_path__ + "static/media/circle-question.9225b5b3.svg";